import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "ssn-display"
}
const _hoisted_2 = { class: "ssn-display__value" }
const _hoisted_3 = ["aria-label"]

import { computed, ref } from 'vue';
import EmptyValueDisplay from '@/components/ui/EmptyValueDisplay.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SsnDisplay',
  props: {
    ssn: {}
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;

const visible = ref(false);
const normalizedSsn = computed(() => {
    const value = props.ssn?.trim();

    if (!value || value === '-' || value === '—') {
        return null;
    }

    return value;
});

function maskSsn(ssn: string): string {
    const parts = ssn.split('-');
    if (parts.length === 3) {
        return `***-**-${parts[2]}`;
    }
    return ssn;
}

return (_ctx: any,_cache: any) => {
  return (!normalizedSsn.value)
    ? (_openBlock(), _createBlock(EmptyValueDisplay, { key: 0 }))
    : (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(visible.value ? normalizedSsn.value : maskSsn(normalizedSsn.value)), 1),
        _createElementVNode("button", {
          type: "button",
          class: "ssn-display__toggle",
          "aria-label": visible.value ? 'Hide SSN' : 'Show SSN',
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (visible.value = !visible.value), ["stop"]))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(visible.value ? 'pi pi-eye-slash' : 'pi pi-eye')
          }, null, 2)
        ], 8, _hoisted_3)
      ]))
}
}

})